package com.routexk.quiz.ui.layouts

import androidx.compose.runtime.Composable
import com.routexk.quiz.ui.components.widgets.BackToTopButton
import com.routexk.quiz.ui.sections.footer.Footer
import com.routexk.quiz.ui.sections.header.NavHeader
import com.routexk.quiz.ui.theme.AppColors
import com.routexk.quiz.ui.utils.responsivePadding
import com.routexk.quiz.utils.PageSeo
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.ColumnScope
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.*

@Composable
fun PageLayout(
    title: String = "Web Template",
    description: String = "",
    ogImage: String = "/og-image.png",
    content: @Composable ColumnScope.() -> Unit
) {
    val colorMode = ColorMode.current
    val colors = AppColors.getColors(colorMode)

    PageSeo(
        title = "Web Template - $title",
        description = description,
        ogImage = ogImage
    )

    Box(
        Modifier
            .fillMaxWidth()
            .minHeight(100.vh)
            .backgroundColor(colors.background)

            .gridTemplateRows { size(1.fr); size(minContent) }
    ) {

        Column(
            Modifier
                .fillMaxSize()
                .gridRow(1),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {

            NavHeader(
                Modifier
                    .position(Position.Fixed)
                    .top(0.px)
                    .zIndex(50)
            )

            Column(
                Modifier
                    .fillMaxSize(),
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                content()
            }

            BackToTopButton()
        }

        Footer(
            Modifier
                .fillMaxWidth()
                .gridRow(2)
        )
    }
}
